import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Gateway, GatewayClassName, NodeEdgeMapper } from '@iotv/datamodel-core';
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Chip, Stack, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import { getItemsByType } from '../../../../data/Wideawake/wideawakeDataFns';
import { GatewayDataGrid } from './GatewayDataGrid';
const debug = process.env.REACT_APP_DEBUG && false;
export const GatewayList = () => {
    const newNEM = new NodeEdgeMapper();
    const [nodeEdgeMapper, setNodeEdgeMapper] = useState(new NodeEdgeMapper());
    const [queryTime, setQueryTime] = useState(undefined);
    const [loadingGateways, setLoadingGateways] = useState(false);
    const getGateways = async () => {
        setLoadingGateways(true);
        const res = await getItemsByType(GatewayClassName);
        debug && console.log('getGateways res', res);
        if (res.data) {
            newNEM.loadItems(res.data.Items);
            setNodeEdgeMapper(newNEM);
            setQueryTime(res.data.durationMs);
        }
        setLoadingGateways(false);
    };
    useEffect(() => {
        getGateways();
    }, []);
    const gateways = nodeEdgeMapper.getNodesOfType(GatewayClassName).map((vob) => new Gateway(vob));
    return (_jsxs(Stack, { gap: 1, children: [_jsxs(Stack, { direction: "row", gap: 0.5, children: [_jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Gateways: ", gateways.length] }) }, "gateways"), isNonNaNNumber(queryTime) && _jsx(Chip, { label: _jsxs(Typography, { variant: "body2", children: ["Query time: ", queryTime, " ms"] }) }, "query_time"), _jsx(IconButton, { color: "primary", onClick: () => getGateways(), sx: { padding: 0.5 }, children: _jsx(RefreshIcon, {}) })] }), _jsx(GatewayDataGrid, { loading: loadingGateways, gateways: gateways })] }));
};
